import { render } from "./AddGroupParticipantForm.vue?vue&type=template&id=27c1019e&ts=true&lang=pug"
import script from "./AddGroupParticipantForm.vue?vue&type=script&lang=ts&setup=true"
export * from "./AddGroupParticipantForm.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/AddGroupParticipantForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27c1019e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27c1019e', __exports__)) {
    console.log('reload')
    api.reload('27c1019e', __exports__)
  }
  
  module.hot.accept("./AddGroupParticipantForm.vue?vue&type=template&id=27c1019e&ts=true&lang=pug", () => {
    console.log('re-render')
    api.rerender('27c1019e', render)
  })

}


export default __exports__